module.exports = __webpack_public_path__ + "img/zx-title.68b8a45b.png";